"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModel = void 0;
const react_1 = require("react");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const create_use_model_1 = require("../core/create-use-model");
const value_1 = require("../core/value");
const use_cosmonaut_1 = require("./use-cosmonaut");
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
exports.useModel = create_use_model_1.createUseModel((queries) => {
    const [, forceRender] = react_1.useReducer((s) => s + 1, 0);
    const cosmonaut = use_cosmonaut_1.useCosmonaut();
    const valuesRef = react_1.useRef([]);
    valuesRef.current = queries
        .map(cosmonaut.read)
        .map((value) => (value_1.isLoadableValue(value) ? value.load() : value));
    const queryKeys = queries
        .map((query) => fast_json_stable_stringify_1.default(query))
        .sort()
        .join(",");
    react_1.useDebugValue(valuesRef.current);
    react_1.useEffect(() => {
        const unsubs = queries.map((query, i) => {
            return cosmonaut.subscribe(query, (value) => {
                const prevValue = valuesRef.current[i];
                if (prevValue.loading !== value.loading ||
                    !fast_deep_equal_1.default(prevValue.error, value.error) ||
                    !fast_deep_equal_1.default(prevValue.data, value.data)) {
                    forceRender();
                }
            });
        });
        return () => {
            unsubs.forEach((unsub) => unsub());
        };
    }, [cosmonaut, queryKeys]);
    return valuesRef.current;
});
